module.exports = __webpack_public_path__ + "static/media/spinner-150px.32977705.svg";